const MuiMonthCalendar = {
  styleOverrides: {
    root: {
      width: "325px",
      padding: "0 10px",
      boxSizing: "border-box"
    }
  }
};
export {
  MuiMonthCalendar
};
